export default __webpack_public_path__ + "static/hr-432df96b0cc578135ab827551ed020ff.png";